import { createReducerFromMap, createDefaultInitialState, createAsyncReducer } from "@coverme/redux";

const initalState = createDefaultInitialState({});

function onPersonVerified(state, action) {
    return action.value;
}

function resetVerification(state, action) {
    return initalState;
}

export const personVerificationReducer = createReducerFromMap(initalState, {
    ...createAsyncReducer("VERIFY_PERSON", onPersonVerified),
    UPDATE_ENTRY_COMPLETE: resetVerification,
});
